import React from "react"
import './sections.css';

export default function Section1()
{
return(
    <section>
<div className="center">
<button  disabled={true} className="btn  btn-lg btn-block coming-soon-btn">
<svg
          id="clock"
          xmlns="http://www.w3.org/2000/svg"
          width="300"
          height="200"
          viewBox="0 0 600 600"
        >
          <g id="face">
            <circle className="circle" cx="300" cy="300" r="253.9" />
            <path
              className="hour-marks"
              d="M300.5 94V61M506 300.5h32M300.5 506v33M94 300.5H60M411.3 107.8l7.9-13.8M493 190.2l13-7.4M492.1 411.4l16.5 9.5M411 492.3l8.9 15.3M189 492.3l-9.2 15.9M107.7 411L93 419.5M107.5 189.3l-17.1-9.9M188.1 108.2l-9-15.6"
            />
            <circle className="mid-circle" cx="300" cy="300" r="16.2" />
          </g>
          <g id="hour" className="rotate3">
            <path className="hour-arm" d="M300.5 298V142" />
            <circle className="sizing-box" cx="300" cy="300" r="253.9" />
          </g>
          <g id="minute" className="rotate">
            <path className="minute-arm" d="M300.5 298V67" />
            <circle className="sizing-box" cx="300" cy="300" r="253.9" />
          </g>
          <g id="second" className="rotate2">
            <path className="second-arm" d="M300.5 350V55" />
            <circle className="sizing-box" cx="300" cy="300" r="253.9" />
          </g>
        </svg>


<span > coming soon...</span>
           </button>

</div>
<div className="text-center coming-soon-header memories">

  <h1 className="FirstTextS1" >The new age of connecting!</h1>

  <p className="SecondTextS1">Build and share your memories <br></br> like never before!</p>

</div>
</section>
)
}